import { ReactNode, useMemo } from 'react'
import { ModalSize, useBottomModal } from '../../contexts/BottomModalContext'
import { useClickOutside } from '../../hooks/useClickOutside'
import * as S from './style'

interface BottomModalProps {
    children: ReactNode
    size?: ModalSize
}

function BottomModal({ children, size = 'small' }: BottomModalProps) {
    const { isBottomModalOpen, closeBottomModal } = useBottomModal()
    const [wrapperRef] = useClickOutside(closeBottomModal)

    const maxWidth = useMemo(() => {
        return {
            small: '485px',
            large: 'calc(100vw - 72px)'
        }[size]
    }, [size])

    return (
        <S.BottomModalBackdrop $isBottomModalOpen={isBottomModalOpen}>
            <S.BottomModal ref={wrapperRef} $maxWidth={maxWidth}>
                {children}
            </S.BottomModal>
        </S.BottomModalBackdrop>
    )
}

export default BottomModal